module.exports = __webpack_public_path__ + "img/iStock-475967893.dd04031d.jpg";